import React from 'react';
import { SearchBar, Profile, useAppLayout } from '@monument/core';
import cn from 'classnames';

export const Header = () => {
  const { menuCollapsed } = useAppLayout();

  return (
    <div className="flex items-center mt-[7px]">
      <div
        className={cn(
          'flex items-center justify-between',
          menuCollapsed ? 'pl-app-menu-collapsed' : 'pl-app-menu-open',
        )}
      >
        <div className="ml-[60px]">
          <SearchBar />
        </div>
      </div>
      <div className="flex ml-auto">
        <div className="mr-[40px]">
          <Profile />
        </div>
      </div>
    </div>
  );
};
